import React from 'react';
import "./Home.css"
import { FaAngleDown } from "react-icons/fa";
import Blogs from '../Blogs/Blogs';
import Projects from '../Projects/Projects';
import Contact from '../Contact/Contact';
import About from '../About/About';
const Home = () => {
    const asd = () => {
        var myrsong = document.getElementById("mySong")
        var icon = document.getElementById("icon")
        if (myrsong.paused) {
            myrsong.play()
            icon.src = "Images/pause.png"
        } else {
            myrsong.pause()
            icon.src = "Images/play.png"
        }
    }
    return (
        <>
            <div className="home" style={{ backgroundImage: "linear-gradient(rgba(4,9,30,0.7),rgba(4,9,30,0.7)),url(Images/im.jpg)" }}>
                <div className="home-in">
                    <div className="container" >
                        <div className="conte">
                            <div>
                                <div className="container-in">
                                    <div className="sm">
                                        <h1><span className="sm1">Welcome to</span>  <br />  <span className="sm2">Imran's world</span></h1>
                                    </div>
                                    <div className="smm">
                                        <h1><span className="listen">Click To Listen me</span> </h1><img src="Images/play.png" id="icon" onClick={asd} alt="" />
                                    </div>
                                </div>
                            </div>
                            <div className="d2">
                                <img width="100%" src="Images/imran.jpg" alt="" />
                                <div className="topimg">
                                    <p>1 years <br /> Experience !</p>
                                </div>
                            </div>
                        </div>
                        <audio id="mySong">
                            <source src="Media/Recording.mp3" />
                        </audio>
                    </div>
                    <div className="centerchek">
                        <a href="#idd" className="checkmyworkbtn"> <p style={{ color: "white", textAlign: "center", paddingBottom: "10px" }}>checkout my works <FaAngleDown /></p></a>
                    </div>
                </div>
            </div>
            <div id="idd">
                <Projects />
            </div>
            <div>
                <Blogs/>
            </div>
            <div>
                <About/>
            </div>
            <div>
                <Contact/>
            </div>
        </>
    );
};

export default Home;